var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tree-select',{staticStyle:{"width":"100%"},attrs:{"treeNodeFilterProp":"title","dropdownStyle":{ maxHeight : '250px' },"tree-data":_vm.actorOptions1,"tree-checkable":"","show-checked-strategy":_vm.SHOW_PARENT,"search-placeholder":"Auswahl"},model:{value:(_vm.actor1),callback:function ($$v) {_vm.actor1=$$v},expression:"actor1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }